import React from 'react';
import type { TeamValue } from '@atlassian/jira-issue-field-team/src/common/types.tsx';
import { TeamValueRenderer } from '@atlassian/jira-polaris-lib-team-value/src/ui/index.tsx';
import type { CommonFieldComponentProps } from '../../common/types.tsx';

export const isTeamFieldComponentProps = (
	props: CommonFieldComponentProps,
): props is TeamFieldComponentProps =>
	'teams' in props && 'value' in props && typeof props.value === 'string';

export type TeamFieldComponentProps = CommonFieldComponentProps & {
	value: string;
	teams: { [key: string]: TeamValue };
};

export const TeamField = ({ value, teams }: TeamFieldComponentProps) => {
	const team = teams[value];
	return <TeamValueRenderer name={team?.name} avatarUrl={team?.avatarUrl} />;
};
